<script setup>
import { useRouter,useRoute } from 'vue-router'
import { useMemberStore, useMetaStore } from './stores'
import { authPageType, get,  post } from './common/util'
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import _ from 'lodash-es'
const metaStore=useMetaStore(),memStore=useMemberStore(),router=useRouter(),route=useRoute(),checkgap=10_000,i18n=useI18n(),inited=ref(false)
const continousCheckLoginAndRenewToken=async()=>{
  if(authPageType(route.path)=='noauth')return setTimeout(continousCheckLoginAndRenewToken,checkgap)
  if(!memStore.isLoggedIn())return router.push('/login')
  if(memStore.expNowDiff('hour')<=1){
    post('rest/authed/member/renewjwt',null,resp=>{
      if(!resp.isSuccess)return router.push('/login')
      memStore.init(resp.data.jwt)
      if(memStore.iss!=='uok-gis'){
        memStore.reset()
        return router.push('/login')
      }
    })
  }
  setTimeout(continousCheckLoginAndRenewToken,checkgap)
}
continousCheckLoginAndRenewToken()
const faviel=document.createElement('link')
faviel.rel='icon'
document.head.appendChild(faviel)

get('rest/public/conf/site_nm',res=>{
  if(res.isSuccess)document.title=res.data.sval
  get('rest/public/dispmode',res=>{
    metaStore.dispmode=res.data
    inited.value=true
  })
})

</script>
<template>
  <v-locale-provider :locale="i18n.locale.value=='us'?'en':'kr'">
    <v-app class="w-screen h-screen ma-0 pa-0">
      <v-overlay :model-value="metaStore.apponoverlay" class="align-center justify-center" :persistent="metaStore.apppersist" @update:model-value="val=>{
        metaStore.apponoverlay=val
        if(!val){
          metaStore.appoverlayonclose()
          metaStore.appoverlayonclose=null
        }
      }">
        <v-progress-circular v-if="metaStore.appisloading" color="primary" size="64" indeterminate/>
        <v-sheet v-else id="popbody">
          <v-card min-width="300" v-if="metaStore.isdialog">
            <v-card-title>{{ metaStore.isdialogtk?$t(metaStore.dialogttl):metaStore.dialogttl }}</v-card-title>
            <v-divider/>
            <v-card-text>
              <div class="ma-2">{{ metaStore.isdialogtk?$t(metaStore.dialogcont):metaStore.dialogcont }}</div>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
              <v-row justify="end">
                <v-btn v-if="metaStore.dialogshowcancel" :text="$t('cancel')" variant="elevated" @click.stop="()=>{
                  metaStore.dialogoncancel()
                  metaStore.dialog({shown:false})
                }"/>
                <v-btn :text="$t('confirm')" class="ms-2 me-3" variant="elevated" color="primary" @click.stop="()=>{
                  metaStore.dialogonok()
                  metaStore.dialog({shown:false})
                }"/>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-sheet>
      </v-overlay>
      <router-view v-if="inited"/>
    </v-app>
  </v-locale-provider>
</template>
<style>
html{overflow-y: auto;}
.v-switch.center .v-selection-control{justify-content:center}
</style>
